import { Box, Card, Typography } from '@mui/material';

type Props = {
  displayName: string;
};

export const BasicInfoCard = ({ displayName }: Props) => {
  return (
    <Card
      sx={{
        mb: 3,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          mx: 3,
          my: 2.5,
        }}
      >
        <Typography variant="h4">{displayName}</Typography>
      </Box>
    </Card>
  );
};
